var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileSemibold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5C3 3.34315 4.34315 2 6 2H15.7574C16.01 2 16.2593 2.03186 16.5 2.09336C16.5436 2.1045 16.5869 2.11661 16.6299 2.12968C17.0971 2.27172 17.527 2.52705 17.8787 2.87868L20.1213 5.12132C20.5053 5.5053 20.7744 5.98265 20.9066 6.5C20.9076 6.5038 20.9086 6.50759 20.9095 6.51139C20.9691 6.74854 21 6.994 21 7.24264V19ZM18 20.5H6C5.17157 20.5 4.5 19.8284 4.5 19V5C4.5 4.17157 5.17157 3.5 6 3.5H15V6C15 7.10457 15.8954 8 17 8H19.5V19C19.5 19.8284 18.8284 20.5 18 20.5ZM19.3033 6.5C19.2375 6.38463 19.1562 6.27752 19.0607 6.18198L16.818 3.93934C16.7301 3.85143 16.6324 3.77556 16.5275 3.71279C16.5184 3.70734 16.5092 3.70199 16.5 3.69674V6C16.5 6.27614 16.7239 6.5 17 6.5H19.3033Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSemibold);
export default __webpack_public_path__ + "static/media/file-semibold.d1548983cce15069ddb3ac0bd133c58c.svg";
export { ForwardRef as ReactComponent };